import { StressAreaTypeModel } from '@app/models/StressAreaTypeModel';
import { StressAreaTypeRepository } from '@app/repositories/StressAreaTypeRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class StressAreaTypeService extends ServiceBase<StressAreaTypeModel, StressAreaTypeRepository<StressAreaTypeModel>> {
    public constructor() {
        super(new StressAreaTypeRepository());
    }
}
